import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      alignItems: 'center',
      borderRadius: '16px',
      color: '#fff',
      display: 'flex',
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: '1.5rem',
      justifyContent: 'space-between',
      paddingInline: '1rem',
      paddingBlock: '0.75rem',
      width: '100%',
    },
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      '& path': {
        fill: '#fff',
      },
    },
    iconDefault: {
      marginInlineEnd: '0.5rem',
    },
    iconClose: {
      cursor: 'pointer',
      padding: '0.25rem',
    },
  },
  { name: 'InlineNotification' },
);
